<template>
	
	<div class="row fixed-header">
	
		<!-- Profile Info and Notifications -->
		<div class="col-md-1 col-sm-1 col-xs-2 clearfix">
	
			<ul class="user-info pull-left pull-none-xsm">
	
				<!-- Profile Info -->
				<li class="profile-info dropdown">
					<a href="#" class="dropdown-toggle" data-toggle="dropdown">
						<img :src="profile()" alt="" class="img-circle profile-img" />
						<span class="profile-name desktop-only">{{this.$parent.user.name}}</span>
					</a>
					<ul class="dropdown-menu">
						<!-- Reverse Caret -->
						<li class="caret"></li>
						<!-- Profile sub-links -->
						<li><router-link to="/profile/"><i class="fa fa-edit"></i> Editar perfil</router-link></li>
						<!-- Cerrar sesión en móviles -->
						<li class="mobile-only"><a @click="$root.handleLogout"><i class="entypo-logout"></i> Cerrar sesión</a></li>
					</ul>
				</li>
	
			</ul>
	
		</div>
	
		<div class="col-md-10 col-sm-10 col-xs-10 clearfix">
			<!-- Primera fila: Búsqueda y botones principales -->
			<div class="form-group header-row">
				<div class="col-sm-6 col-xs-12 search-container">
					<div class="input-group">
						<input class="form-control" v-model="search.keywords" name="row_keywords" placeholder="Search" @keyup.enter="searchData">
						<span class="input-group-btn">
							<a class="btn btn-info btn-sm" @click="searchData"><i class="fa fa-search"></i></a>
						</span>
					</div>
				</div>
				<div class="col-sm-3 col-xs-6 button-container">
					<router-link :to="'/orders/edit'">
			        	<button class="btn btn-info btn-sm btn-header">
				            <i class="fa fa-plus"></i> <span class="btn-text">Reservation</span>
				        </button>
			        </router-link>
				</div>
				<div class="col-sm-3 col-xs-6 button-container">
					<router-link :to="'/incidents/edit'">
					<button class="btn btn-danger btn-sm btn-header">
						<i class="fa fa-plus"></i> <span class="btn-text">Incident</span>
					</button>
					</router-link>
				</div>
			</div>
			
			<!-- Segunda fila: Marquee (oculto en móviles muy pequeños) -->
			<div class="form-group header-row marquee-row">
				<div class="col-sm-12 col-xs-12">
					<div class="marquee-container">
						<div class="marquee-text" v-html="row.tickers"></div>
					</div>
				</div>
			</div>

			
		</div>
		<!-- Raw Links -->
		<div class="col-md-1 col-sm-1 clearfix hidden-xs">
			<ul class="list-inline links-list pull-right">	
				<li><a @click="$root.handleLogout">Cerrar session <i class="entypo-logout right"></i></a></li>
			</ul>
		</div>
		
		
	</div>
	
</template>

<script type="text/javascript">
	export default {
		data(){
			return {
				row:{
					tickers:null
				},
				search:{
					keywords:null,
				}
			}
		},

		methods:{
			profile(){
				return ('https://ui-avatars.com/api/?name='+this.$parent.user.name+'&size=256');
			},
			
			getTicker(){
				
				axios.get(tools.url('/api/admin/tickersLasts')).then((response)=>{
					this.row.tickers = response.data;
			    }).catch((error)=>{
			    });
			},
			searchData(){
				this.$router.push('/orders?keywords='+this.search.keywords)
			}
		},
		mounted(){
			this.getTicker();
		}
    }
</script>
<style>
.custom-toast {
  font-size: 15px;
}

.marquee-container {
  overflow: hidden;
  position: relative;
  width: 100%;
  white-space: nowrap;
}

.marquee-text {
  display: inline-block;
  padding-left: 100%;
  animation: marquee 15s linear infinite;
  white-space: nowrap;
}

@keyframes marquee {
  0%   { transform: translateX(0%); }
  100% { transform: translateX(-100%); }
}

/* Clases para mostrar/ocultar en diferentes tamaños */
.desktop-only {
  display: inline;
}

.mobile-only {
  display: none;
}

/* Estilos para header fijo */
.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  left: 250px;
  z-index: 1000;
  background: white;
  border-bottom: 1px solid #ddd;
  padding: 10px 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin: 0;
  width: calc(100% - 250px);
}

.fixed-header .form-group {
  margin-bottom: 5px;
}

.fixed-header .header-row {
  margin-bottom: 5px;
}

/* Perfil */
.profile-img {
  width: 44px;
  height: 44px;
}

.profile-name {
  margin-left: 8px;
}

.profile-name-mobile {
  display: none;
}

/* Botones del header */
.btn-header {
  width: 100%;
  white-space: nowrap;
}

.button-container {
  padding: 5px;
}

.search-container {
  padding: 5px;
}

.input-group-btn {
  width: auto;
}

/* Marquee */
.marquee-row {
  margin-bottom: 0;
  padding: 5px 0;
}

.marquee-container {
  height: 25px;
  line-height: 25px;
}

/* Ajuste para el contenido principal */
.page-container .main-content {
  margin-left: 250px;
  padding-top: 120px;
  width: calc(100% - 250px);
  background: #ffffff !important;
  display: block !important;
  position: relative !important;
}

/* Asegurar que el sidebar esté fijo */
.page-container .sidebar-menu {
  position: fixed !important;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 1001;
  width: 250px;
}

/* Responsive para móviles */
@media (max-width: 768px) {
  .desktop-only {
    display: none !important;
  }

  .mobile-only {
    display: inline !important;
  }

  .fixed-header {
    left: 0;
    width: 100%;
    padding: 5px 0;
  }

  .fixed-header .form-group {
    margin-bottom: 3px;
  }

  .fixed-header .header-row {
    margin-bottom: 3px;
  }

  /* Perfil más compacto en móviles */
  .profile-img {
    width: 32px;
    height: 32px;
  }


  .profile-info > a {
    padding: 5px;
  }

  /* Botones más compactos */
  .btn-header {
    font-size: 11px;
    padding: 4px 8px;
  }

  .btn-header .btn-text {
    display: inline;
  }

  .button-container {
    padding: 3px;
  }

  .search-container {
    padding: 3px;
  }

  .search-container .form-control {
    font-size: 14px;
    padding: 6px 10px;
  }

  .search-container .btn {
    padding: 6px 10px;
  }

  /* Marquee más pequeño o oculto */
  .marquee-row {
    display: none; /* Ocultar marquee en móviles para ahorrar espacio */
  }

  /* Ajustar layout de columnas */
  .fixed-header .col-xs-12 {
    padding-left: 5px;
    padding-right: 5px;
  }

  .fixed-header .col-xs-6 {
    padding-left: 3px;
    padding-right: 3px;
  }

  .fixed-header .col-xs-2 {
    padding-left: 5px;
    padding-right: 5px;
  }

  .fixed-header .col-xs-10 {
    padding-left: 5px;
    padding-right: 5px;
  }

  /* Ajustar input group */
  .input-group {
    display: flex;
  }

  .input-group .form-control {
    flex: 1;
  }

  .input-group-btn {
    flex-shrink: 0;
  }
  
  .page-container .main-content {
    margin-left: 0;
    width: 100%;
    padding-top: 100px; /* Reducido para móviles */
  }
  
  .page-container .sidebar-menu {
    width: 250px;
  }

  /* Ajustar dropdown del perfil */
  .dropdown-menu {
    min-width: 180px;
  }
}

/* Para pantallas muy pequeñas */
@media (max-width: 480px) {
  .fixed-header {
    padding: 3px 0;
  }

  .btn-header {
    font-size: 10px;
    padding: 3px 6px;
  }

  .btn-header .fa {
    font-size: 10px;
  }

  .profile-img {
    width: 28px;
    height: 28px;
  }

  .page-container .main-content {
    padding-top: 90px;
  }
}

</style>